module.exports = __webpack_public_path__ + "static/media/Roboto-700.ee7b96fa.ttf";